import { isBefore } from 'date-fns';

export const sortDates = (dates: string[]): string[] => {
  const filteredDates = dates.filter((date) => date !== null && date !== undefined);
  return filteredDates.sort((a, b) => (isBefore(a, b) ? -1 : 1));
};

